(function() {
'use strict';

angular
    .module('TR')
    .service('hotelRehydrator', hotelRehydrator);

function hotelRehydrator(fieldFilterParser, $routeParams, $http, arrayUtil, imageService, $q, $filter, tripService, hotelFromSession, fieldGroupService) {
    const service = {
        hotels,
        hotel,
        staticHotel
    };

    const fieldTypes = fieldGroupService.getFieldTypes();
    const fieldFlags = fieldGroupService.getFieldGroup([
        fieldTypes.Global,
        fieldTypes.Titles,
        fieldTypes.IndicativePrice,
        fieldTypes.ReviewSnippets,
        fieldTypes.Url,
        fieldTypes.Summary,
        fieldTypes.Recommendations
    ]);

    function hotel(id) {
        if ($routeParams.tripId) {
            return tripService.getTrip($routeParams.tripId).then(function(trip) {
                return hotelFromSession.getHotel(trip.HotelsRequest.AvailabilitySearchId, id, $routeParams.tripId);
            });
        }
        return staticHotel(id);
    }

    function staticHotel(id, ignoreErrors) {
        const dim = TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize;
        return hotels([id], { imageWidth: dim, imageHeight: dim }, ignoreErrors).then(function(data) {
            return data[0];
        });
    }

    function hotels(ids, options, ignoreErrors) {
        options = angular.extend({ imageWidth: 80, imageHeight: 80, cropImage: false }, options);
        if (ids == null || ids.length === 0) {
            return $q.when([]);
        }
        return $http.post(`/api/hotels/static/gethotelsbyid?${fieldFilterParser.parse(options)}`, {
            Ids: ids,
            CultureCode: TRPCONFIG.Domain.CultureCode,
            CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
            DomainId: TRPCONFIG.Domain.DomainId,
            FieldFlags: fieldFlags
        }, { ignoreErrors: !!ignoreErrors }).then(function(result) {
            return arrayUtil.map(result.data, function(hotel) {
                hotel.ImageUrl = imageService.getMainImageUrl(hotel.Id, options.imageWidth, options.imageHeight, options.cropImage);
                hotel.TeaserStr = $filter('roundedCurrency')(hotel.IndicativeMinPrice);
                return hotel;
            });
        });
    }

    return service;
}
})();
